import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { t } from "../i18n";

export async function pickProfilePhoto(): Promise<string | null> {
  try {
    const photo = await Camera.getPhoto({
      quality: 85,
      allowEditing: false,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Prompt,
      presentationStyle: 'popover',
      saveToGallery: false,
      webUseInput: true,
      // Founder decision: two options only, labeled the iOS way.
      promptLabelHeader: t("pickProfilePhoto.addAPhoto"),
      promptLabelPhoto: t("pickProfilePhoto.photoLibrary"),
      promptLabelPicture: t("pickProfilePhoto.takePhoto"),
    });
    return photo?.dataUrl || null;
  } catch (e) {
    return null;
  }
}
